<template>
  <div class="py-4 container-fluid">
    <div class=" row">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center justify-content-between">
              <h6 class="mb-0 section-title">Lista de Horno</h6>
              <div class="d-flex gap-2">
                <button type="button" class="btn btn-sm bg-gradient-success mb-0" @click="downloadCargueExcel"
                  :disabled="downloadingCargueExcel" data-toggle="tooltip" data-original-title="Descargar reporte Excel cargue">
                  <i class="fa fa-file-excel me-1"></i> {{ downloadingCargueExcel ? 'Descargando...' : 'Excel Cargue' }}
                </button>
                <router-link :to="{ name: 'Oven Create' }" class="btn btn-sm bg-gradient-warning mb-0"
                  data-toggle="tooltip" data-original-title="Agregar registro">
                  Agregar <i class="fa fa-plus ms-1"></i>
                </router-link>
              </div>
            </div>

            <!-- se agg una row mas para la busqueda-->
            <div class="row">

              <!-- Columna de búsqueda -->
              <div class="col-md-6 mb-3">
                <label for="searchQuery" class="mb-1">Buscar</label>
                <input type="text" v-model="searchQuery" id="searchQuery" class="form-control"
                  placeholder="Buscar producción..." @input="fetchData(null)" />
              </div>

              <!-- Columna de fechas -->
              <div class="col-md-3 mb-3">
                <label for="startDate" class="mb-1">Desde</label>
                <input type="date" v-model="startDate" id="startDate" class="form-control" @change="fetchData(null)" />
              </div>
              <div class="col-md-3 mb-3">
                <label for="endDate" class="mb-1">Hasta</label>
                <input type="date" v-model="endDate" id="endDate" class="form-control" @change="fetchData(null)" />
              </div>

            </div>


          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">

              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">#</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Horno</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Creado por</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Fecha de incio</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Fecha estimada de entrega</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Fecha de Finalizacíon</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Fecha de creación</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Estado</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="value in tableData" :key="value.id">
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ value.id }}</h6>
                        </div>
                      </div>
                    </td>

                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ value?.oven?.name }}</h6>
                        </div>
                      </div>
                    </td>
                    
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm text-secondary font-weight-bold text-xs">{{ value?.user?.name ?? "No encontrado" }}</h6>
                        </div>
                      </div>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">

                        {{ new Date(value.started_at).toLocaleDateString('es-ES') }}                      
                      </span>
                    </td>

                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">

                        {{ new Date(value.estimated_at).toLocaleDateString('es-ES') }}                      
                      </span>
                    </td>

                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">

                        {{ new Date(value.finished_at).toLocaleDateString('es-ES') }}                      
                      </span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">

                        {{ new Date(value.created_at).toLocaleDateString('es-ES') }}                      
                      </span>
                    </td>

                    <td class="align-middle text-center text-sm">
                      <span class="badge badge-sm" :class="{
                        'bg-gradient-warning': value.status === 0,  // Pendiente
                        'bg-gradient-primary': value.status === 1,  // Producción
                        'bg-gradient-success': value.status === 2,  // Terminado
                        'bg-gradient-info': value.status === 3      // Despachado
                      }">
                        {{
                          value.status === 0 ? 'Pendiente' :
                            value.status === 1 ? 'Activo' :
                              value.status === 2 ? 'Terminado' :
                                value.status === 3 ? 'Desconocido' : 'Desconocido'
                        }}
                      </span>
                    </td>
                    <td class="align-middle text-center">
                      <router-link
                        :to="{ name: 'Oven Create', params: { data: JSON.stringify(value) }, props: true }"
                        class="text-secondary font-weight-bold text-xs" data-toggle="tooltip"
                        :data-original-title="value.status === 2 ? 'Ver registro' : 'Editar Registro'">
                        <i :class="value.status === 2 ? 'fa fa-eye' : 'fa fa-pencil-alt'"></i>
                      </router-link>

                      <a v-if="value.status === 0" @click="deleteUser(value.id)"
                        class="text-secondary font-weight-bold text-xs cursor-pointer" style="margin-left: 15px;"
                        data-toggle="tooltip" data-original-title="Eliminar registro">
                        <i class="fa fa-trash"></i>
                      </a>
                    </td>
                  </tr>

                  <tr v-if="tableData.length === 0">
                    <td colspan="9" class="text-center text-xxs">No hay registros disponibles</td>
                  </tr>

                </tbody>
              </table>

              <!-- Paginación -->
              <div class="pagination p-3">
                <a v-for="link in links" :key="link.label" class="page-item cursor-pointer" @click="fetchData(link.url)"
                  :disabled="!link.url || link.active" :class="{ 'active': link.label === currentPage.toString() }">
                  {{ link.label }}
                </a>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2';
export default {
  name: 'ProjectsTable',
  data() {
    return {
      searchQuery: '', // Para el campo de búsqueda
      startDate: '',   // Para la fecha de inicio
      endDate: '',     // Para la fecha de fin
      downloadingCargueExcel: false
    };
  },
  computed: {
    ...mapGetters('productionOven', ['allData', 'currentPage', 'lastPage', 'pagination', 'links']), // Mapea el getter allUsers
    currentPage() {
      return this.$store.state.productionOven.currentPage; // Obtiene la página actual
    },
    lastPage() {
      return this.$store.state.productionOven.lastPage; // Obtiene la última página
    },
    tableData() {
      return this.allData || []; // Listado de hornos desde el store
    },
    links() {
      return this.$store.getters['productionOven/links']; // Retorna los links
    },
  },
  methods: {
    async fetchData(pageUrl = null) {

      const params = {
        search: this.searchQuery,
        start_date: this.startDate,
        end_date: this.endDate,
        page: pageUrl ? new window.URL(pageUrl).searchParams.get("page") || 1 : 1
      };

      await this.$store.dispatch('productionOven/fetchData', params);
    },
    async downloadCargueExcel() {
      this.downloadingCargueExcel = true;
      try {
        const analitycService = (await import('@/services/analityc.service.js')).default;
        const response = await analitycService.getReportCargueReport({
          start_date: this.startDate || undefined,
          end_date: this.endDate || undefined,
          search: this.searchQuery || undefined
        });
        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'reporte_cargue_ceramicas_america.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error al descargar Excel cargue:', error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || 'No se pudo descargar el reporte de cargue.'
        });
      } finally {
        this.downloadingCargueExcel = false;
      }
    },
    async deleteUser(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("productionOven/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {

            this.fetchData(null);

            await Swal.fire(
              'Eliminado!',
              'El registro se ha sido eliminado correctamente.',
              'success'
            );
          } else {
            throw new Error(response.data.message || 'Error al eliminar el Empleado');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    }

  },
  mounted() {
    this.fetchData(null); // Llama a fetchUsers cuando el componente se monta
  },
};
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.page-item {
  margin: 0 5px;
}

.active {
  font-weight: bold;
  /* Estilo para la página activa */
}

.section-title {
  font-weight: 800;
  color: #1f2d5a;
  letter-spacing: 0.6px;
}

.section-title::after {
  content: "";
  display: block;
  width: 44px;
  height: 3px;
  margin-top: 6px;
  border-radius: 999px;
  background: #f6a500;
}
</style>